(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alpha-header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  document.querySelectorAll('.ap-header .ap-nav-disclosure[open]').forEach((menu) => {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.ap-header .ap-nav-disclosure[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
window.addEventListener('resize', () => {
  document.querySelectorAll('.ap-header .ap-nav-disclosure[open]').forEach((menu) => {
    if (menu.getBoundingClientRect().width === 0) menu.open = false;
  });
}, { passive: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
